import React from 'react';
import {
    ContentEnum,
    ContentWrapperConfigProps,
    DisplaySectionName,
    LandingPageMainContentVariant,
    LandingPageTopContentVariant,
    ReviewSectionSpecificProps,
    TitleSectionSpecificProps,
    MosaicGallerySpecificProps,
} from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { AtAGlanceSectionProps } from 'component/page/detail/DetailCard/Overview/AtAGlanceSectionModular';
import { PackageOptionsModularProps } from 'component/page/detail/PackageOptions/PackageOptionsModular.types';
import { RootState } from 'store/store.types';

export const REVIEW_SECTION_HREF = 'review-section';
export const PACKAGE_OPTIONS_HREF = 'package-options';

export interface ContentHandlerProps {
    contents: ContentConfig[];
    titleCms?: number;
    elementName?: string;
    href?: string;
}

export interface DynamicContentProps<K extends keyof typeof ContentPropsMap> {
    createComponent: () => React.ComponentType<(typeof ContentPropsMap)[K]>;
    titleCms?: number;
    elementName: string;
    href: string;
    isPrerenderHide?: boolean;
    contentValidation?: (state: RootState) => boolean;
    getTitle?: (state: RootState) => string | null;
}

export type ContentRegistryType = {
    [K in keyof typeof ContentPropsMap]: DynamicContentProps<K>;
};
export const ContentPropsMap = {
    [ContentEnum.VerticalContentHandler]: {} as ContentHandlerProps,
    [ContentEnum.TabsContentHandler]: {} as ContentHandlerProps,
    [ContentEnum.Breadcrumb]: {},
    [ContentEnum.TitleSection]: {} as TitleSectionSpecificProps,
    [ContentEnum.PackageOptions]: {} as PackageOptionsModularProps,
    [ContentEnum.ReviewSection]: {} as ReviewSectionSpecificProps,
    [ContentEnum.AtAGlance]: {} as AtAGlanceSectionProps,
    [ContentEnum.MosaicGallery]: {} as MosaicGallerySpecificProps,
    [ContentEnum.Highlight]: {},
    [ContentEnum.ExploringActivitiesCarousel]: {},
    [ContentEnum.AdditionalInformation]: {},
    [ContentEnum.CancellationPolicy]: {},
    [ContentEnum.IntroductionSummary]: {},
    [ContentEnum.SimCardSpec]: {},
    [ContentEnum.DepartureAndReturn]: {},
    [ContentEnum.WhatToExpect]: {},
    [ContentEnum.Location]: {},
    [ContentEnum.SuggestedRoute]: {},
    [ContentEnum.FAQs]: {},
    [ContentEnum.AboutActivity]: {},
} satisfies Record<ContentEnum, unknown>;

export interface DetailPageDisplayConfig {
    [DisplaySectionName.LandingPageTop]: {
        contents: ContentConfig[];
        variant: LandingPageTopContentVariant;
    };
    [DisplaySectionName.LandingPageMain]: {
        contents: ContentConfig[];
        variant: LandingPageMainContentVariant;
    };
    [DisplaySectionName.InfoOverlay]: {
        contents: ContentConfig[];
    };
}

export type ContentConfig = {
    [K in keyof typeof ContentPropsMap]: {
        content: K;
        wrapperProps: ContentWrapperConfigProps;
        contentProps: (typeof ContentPropsMap)[K];
    };
}[keyof typeof ContentPropsMap];

export interface ContentHandlerMetaInfo {
    titleCms: number;
    dynamicTitle?: string;
    href: string;
    elementName: string;
}
